import { useState } from 'react';

type ConfirmAction = () => Promise<void> | void;

type ConfirmState = {
  open: boolean;
  title: string;
  description: string;
  confirmLabel: string;
  onConfirm: ConfirmAction | null;
};

const INITIAL_STATE: ConfirmState = {
  open: false,
  title: '',
  description: '',
  confirmLabel: 'Delete',
  onConfirm: null,
};

const useActionPlansConfirmModal = () => {
  const [state, setState] = useState<ConfirmState>(INITIAL_STATE);
  const [loading, setLoading] = useState(false);

  const openConfirm = (
    title: string,
    description: string,
    onConfirm: ConfirmAction,
    confirmLabel = 'Delete'
  ) => {
    setState({
      open: true,
      title,
      description,
      confirmLabel,
      onConfirm,
    });
  };

  const closeConfirm = () => {
    if (loading) {
      return;
    }
    setState(INITIAL_STATE);
  };

  const handleConfirm = async () => {
    if (!state.onConfirm) {
      return;
    }

    setLoading(true);
    try {
      await state.onConfirm();
      setState(INITIAL_STATE);
    } finally {
      setLoading(false);
    }
  };

  return {
    openConfirm,
    confirmModalProps: {
      open: state.open,
      title: state.title,
      description: state.description,
      confirmLabel: state.confirmLabel,
      loading,
      onConfirm: handleConfirm,
      onCancel: closeConfirm,
    },
  };
};

export default useActionPlansConfirmModal;
